import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@e2n/ui/v2';
import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import type { AbgleichZeile } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';
import { istUebernehmbar } from '../../hooks/useMitarbeiterabgleich/uebernahme';
import { ABGLEICH_ZEILE_CLASS } from './abgleichKonstanten';

export function UebernehmenSpalte({
  zeilen,
  onUebernehmen,
  disabled,
}: {
  zeilen: AbgleichZeile[];
  onUebernehmen: (zeile: AbgleichZeile) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center">
      <div className="h-17 shrink-0" />
      {zeilen.map((zeile) => (
        <div
          key={zeile.id}
          className={cn(
            'flex shrink-0 items-center justify-center',
            ABGLEICH_ZEILE_CLASS,
          )}>
          <Button
            variant="outline"
            size="small"
            iconOnly
            disabled={disabled || !istUebernehmbar(zeile)}
            onClick={() => onUebernehmen(zeile)}
            aria-label={t('domain.datev.abgleich.zeileUebernehmen', {
              id: zeile.id,
            })}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
        </div>
      ))}
    </div>
  );
}
